module.exports = __webpack_public_path__ + "static/media/PDF_40.7d8c11b3.pdf";